import React, {useContext, useEffect, useState} from "react";
import Header from "../components/header/Header";
import Greeting from "./greeting/Greeting";
import WorkExperience from "./workExperience/WorkExperience";
import StartupProject from "./StartupProjects/StartupProject";
import Blogs from "./blogs/Blogs";
import Skills from "./skills/Skills";
import Achievement from "./achievement/Achievement";
import Contact from "./contact/Contact";
import Footer from "../components/footer/Footer";
import SplashScreen from "./splashScreen/SplashScreen";
import ScrollToTopButton from "./topbutton/Top";
import ScrollProgress from "../components/scrollProgress/ScrollProgress";
import {splashScreen} from "../portfolio";
import StyleContext from "../contexts/StyleContext";
import "./Main.scss";

const Main = () => {
  const {isDark} = useContext(StyleContext);
  const [isShowingSplashAnimation, setIsShowingSplashAnimation] =
    useState(true);

  useEffect(() => {
    if (splashScreen.enabled) {
      const splashTimer = setTimeout(
        () => setIsShowingSplashAnimation(false),
        splashScreen.duration
      );
      return () => {
        clearTimeout(splashTimer);
      };
    }
  }, []);

  return (
    <>
      <div className={isDark ? "dark-mode" : null}>
        <ScrollProgress />
        {isShowingSplashAnimation && splashScreen.enabled ? (
          <SplashScreen />
        ) : (
          <>
            <Header />
            <Greeting />
            <WorkExperience />
            <StartupProject />
            <Skills />
            <Blogs />
            <Achievement />
            <Contact />
            <Footer />
            <ScrollToTopButton />
          </>
        )}
      </div>
    </>
  );
};

export default Main;
